import React, { useState } from "react";
import styles from "./css/FranchiseLanding.module.css";
import Navbar from "../Navbar/Navbar";
import man from "../assets/Layer.png";
import { Container, Row, Col, Form, Button, Image } from "react-bootstrap";
import ReCAPTCHA from "react-google-recaptcha";

const locationData = {
  "Madhya Pradesh": {
    Bhopal: ["Bhopal", "Berasia", "Kolar"],
    Indore: ["Indore", "Depalpur", "Mhow"],
    Gwalior: ["Gwalior", "Dabra", "Bhitarwar"],
  },
  "Uttar Pradesh": {
    Lucknow: ["Lucknow", "Malihabad", "Mohanlalganj"],
    Varanasi: ["Varanasi", "Ramnagar", "Chiraigaon"],
    "Kanpur Nagar": ["Kanpur", "Bithoor", "Ghatampur"],
  },
  // ...add all states/districts/cities here
};

export default function FranchiseLanding() {
  const [validated, setValidated] = useState(false);
  const [captchaValue, setCaptchaValue] = useState(null);

  const handleSubmit = (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }

    setValidated(true);
  };

  const [active, setActive] = useState("signIn");

  const [state, setState] = useState("");
  const [district, setDistrict] = useState("");
  const [city, setCity] = useState("");

  const states = Object.keys(locationData);
  const districts = state ? Object.keys(locationData[state]) : [];
  const cities = state && district ? locationData[state][district] : [];
  const [verified, setVerified] = useState(false);

  const handleCaptchaChange = (value) => {
    if (value) {
      setVerified(true); // reCAPTCHA passed
    } else {
      setVerified(false); // reCAPTCHA cleared or expired
    }
  };
  return (
    <div className={styles.ladningbg}>
      <Navbar />
      <br />
      <div className={styles.container}>
        <div className={styles.containerrow}>
          
          <div className={styles.formbox}>
            <div style={{ width: "70%" }}>
              <h1
                style={{
                  fontFamily: "Inter, sans-serif",
                  color: "#000000ff",
                  fontSize: "31px",
                  fontWeight: "800",
                }}
              >
                Franchise Application
              </h1>
              <span>Fill your details and we will get back to you</span>

              <Form
                noValidate
                validated={validated}
                onSubmit={handleSubmit}
                style={{ marginTop: 15 }}
              >
                <Row className="mb-3">
                  <Col md={6} className="mb-3 mb-md-0">
                    <Form.Group controlId="fullName">
                      <Form.Label style={{fontWeight:"500",fontSize:14}}>Full Name</Form.Label>
                      <Form.Control
                        required
                        type="text"
                        placeholder="Enter your full name"
                        style={{
                          padding: "0.6rem",
                          fontSize: 12,
                          borderRadius: "6px",
                          border: "1px solid #ccc",
                                                  }}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Label style={{fontWeight:"500",fontSize:14}}>Email</Form.Label>
                    <Form.Control
                      required
                      type="email"
                      placeholder="Email"
                      style={{
                        padding: "0.6rem",
                         fontSize: 13,
                        borderRadius: "6px",
                        border: "1px solid #ccc",
                      }}
                    />
                  </Col>
                </Row>
                {/* <Row className="mb-3">
                  <Col md={12}>
                    <Form.Label style={{fontWeight:"500",fontSize:14}}>Email</Form.Label>
                    <Form.Control
                      required
                      type="email"
                      placeholder="Email"
                      style={{
                        padding: "0.6rem",
                         fontSize: 13,
                        borderRadius: "6px",
                        border: "1px solid #ccc",
                      }}
                    />
                  </Col>
                </Row> */}
                <Row className="mb-3">
                  <Col md={6} className="mb-3 mb-md-0">
                    <Form.Label style={{fontWeight:"500",fontSize:14}}>Mobile Number</Form.Label>
                    <Form.Control
                      required
                      type="tel"
                      placeholder="10-digit Mobile Number"
                      pattern="[0-9]{10}"
                      maxLength={10}
                      style={{
                        padding: "0.6rem",
                         fontSize: 12,
                        borderRadius: "6px",
                        border: "1px solid #ccc",
                      }}
                    />
                     <Form.Check
                      type="checkbox"
                      id="whatsappCheck"
                      
                      label="This is my WhatsApp number"
                      style={{
                        marginTop: "10px",
                        fontSize: "0.9rem",
                        color: "#555",
                      }}
                    />
                  </Col>

                  <Col
                    md={6}
                    style={{ display: "flex", justifyContent: "center" }}
                  >
                     <Col md={12}>
                    <Form.Label style={{fontWeight:"500",fontSize:14}}>Pincode</Form.Label>
                    <Form.Control
                      required
                      type="text"
                      placeholder="Pincode"
                      style={{
                        padding: "0.6rem",
                        fontSize: 12,
                        borderRadius: "6px",
                        border: "1px solid #ccc",
                      }}
                    />
                  </Col>
                  </Col>
                </Row>
               
                <Row className="mb-3">
                  <Col md={4} className="mb-3 mb-md-0">
                    <Form.Label style={{fontWeight:"500",fontSize:14}}>State</Form.Label>
                    <Form.Select
                      required
                      value={state}
                      onChange={(e) => {
                        setState(e.target.value);
                        setDistrict("");
                        setCity("");
                      }}
                      style={{
                        padding: "0.6rem",
                        borderRadius: "6px",
                        fontSize: 12,
                        border: "1px solid #ccc",
                        color: state ? "#000" : "#888",
                      }}
                    >
                      <option value="">Select State</option>
                      {states.map((s) => (
                        <option key={s} value={s}>
                          {s}
                        </option>
                      ))}
                    </Form.Select>
                  </Col>
                  <Col md={4}>
                    <Form.Label style={{fontWeight:"500",fontSize:14}}>District</Form.Label>
                    <Form.Select
                      required
                      value={district}
                      onChange={(e) => {
                        setDistrict(e.target.value);
                        setCity("");
                      }}
                      disabled={!state}
                      style={{
                        padding: "0.6rem",
                        borderRadius: "6px",
                        fontSize: 12,
                        border: "1px solid #ccc",
                        color: district ? "#000" : "#888",
                      }}
                    >
                      <option value="">Select District</option>
                      {districts.map((d) => (
                        <option key={d} value={d}>
                          {d}
                        </option>
                      ))}
                    </Form.Select>
                  </Col>
                  <Col md={4}>
                    <Form.Label style={{fontWeight:"500",fontSize:14}}>City</Form.Label>
                    <Form.Select
                      required
                      value={city}
                      onChange={(e) => setCity(e.target.value)}
                      disabled={!district}
                      style={{
                        padding: "0.6rem",
                        fontSize: 12,
                        borderRadius: "6px",
                        border: "1px solid #ccc",
                        color: city ? "#000" : "#888",
                      }}
                    >
                      <option value="">Select City</option>
                      {cities.map((c) => (
                        <option key={c} value={c}>
                          {c}
                        </option>
                      ))}
                    </Form.Select>
                  </Col>
                </Row>

                <Row className="mb-4">
                  <Col md={6}>
                    <ReCAPTCHA
                      sitekey="YOUR_SITE_KEY"
                      onChange={handleCaptchaChange}
                      style={{
                        transform: "scale(0.82)", // Scale down or up
                        transformOrigin: "0 0", // Make scaling start from top-left
                        display: "inline-block", // Prevent stretching
                      }}
                    />
                  </Col>
                </Row>

                <div>
                  <Button
                    type="submit"
                    disabled={!verified}
                    style={{
                      backgroundColor: "#07448E",
                      borderColor: "#07448E",
                      color: "#fff",
                      fontSize: "1rem",
                      padding: "0.5rem 2rem",
                      borderRadius: "6px",
                      minWidth: "140px",
                    }}
                  >
                    Submit Application
                  </Button>
                  <span style={{ marginLeft: 10, fontSize: 14, color: "gray" }}>
                    Protected by reCAPTCHA v3
                  </span>
                </div>
              </Form>
            </div>
            <div
              style={{
                width: "28%",
                padding: 10,
                boxSizing: "border-box",
                borderLeft: "1px solid #eeeeeeff",
              }}
            >
              <h3 style={{ fontWeight: "700" }}>Why partner with us ?</h3>
              <ul className={styles.ulCustom}>
                <li>Low initial investment</li>
                <li>Marketing & lead support</li>
                <li>Training & SOPs provided</li>
                <li>Nationwide service coverage</li>
                <li>Dedicated partner success team</li>
              </ul>
              <div
                style={{
                  backgroundColor: "#f6f9ff",
                  height: 100,
                  width: "100%",
                  bottom: 0,
                  borderRadius: 10,
                  marginTop: 280,
                  padding: 10,
                }}
              >
                <h6 style={{ fontWeight: "700" }}>Need help ?</h6>
                <span style={{ fontSize: 12 }}>
                  Call us at +91 98XXXXXX85 or email support@gmail.com
                </span>
              </div>
            </div>
          </div>

        </div>
      </div>

      <div className={styles.mobileContainer}>
        <div style={{width:"60%"}}>
           <h1 className={styles.headingoflanding}>
                Franchise Business Opportunity
              </h1>
              <p className={styles.partnerJointext}>
                Join our extensive franchise network across India, USA,
                Singapore, UAE and many more
              </p>
        </div>
        <div className={styles.containercol2}>
            <Image src={man} alt="men" className={styles.imggirl} />
          </div>
      </div>
          


    </div>
  );
}
